import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from './ProtectedRoute'
import { HomePage } from '../PagesV1/Home'
import { Stepdown } from '../PagesV1/Stepdown'
import { Service } from '../PagesV1/Services'
import { Platforms } from '../PagesV1/Platforms'
import { Teams } from '../PagesV1/Teams'
import { TermsConditionsUse } from '../PagesV1/Legal/TermsConditionsUse'
import { TermsConditionsSale } from '../PagesV1/Legal/TermsConditionsSale'
import { Privacy } from '../PagesV1/Legal/PrivacyPolicy'
import { Cookie } from '../PagesV1/Legal/CookiePolicy'
import { IntellectualProperty } from '../PagesV1/Legal/IntellectualProperty'
import { AlexaFlourSecondary } from '../PagesV1/Products/AlexaFlourSecondary'
import { ProductRelease } from '../PagesV1/ProductRelease'
import { NIR } from '../PagesV1/NIR'
import { Gallery } from '../PagesV1/Gallery'
import { Pathways } from '../PagesV1/Pathways'
import { Methods } from '../PagesV1/Support/Methods'
import { Storm } from '../PagesV1/Support/Storm'
import { Guarantee } from '../PagesV1/Support/Guarantee'
import { Cart } from '../PagesV1/Cart'
import { Checkout } from '../PagesV1/Checkout'
import { Orders } from '../PagesV1/Profile/orders'
import { ProfileInformation } from '../PagesV1/Profile/information'
import { TaxExempt } from '../PagesV1/Profile/taxExempt'
import { ShippingAddress } from '../PagesV1/Profile/shippingAddress'
import { BillingAddress } from '../PagesV1/Profile/billingAddress'
import { OEM } from '../PagesV1/OEM'
import Error from '../pages/Error'

export const V1Router = () => {
    return (
        <Routes>
            <Route index element={<HomePage />} />
            <Route exact path='home' element={<HomePage />} />
            <Route exact path='/stepdown' element={<Stepdown />} />
            <Route exact path='/service' element={<Service />} />
            <Route exact path='/platforms' element={<Platforms />} />
            <Route exact path='/teams' element={<Teams />} />
            <Route exact path='/terms-and-conditions-of-use' element={<TermsConditionsUse />} />
            <Route exact path='/terms-and-conditions-of-sale' element={<TermsConditionsSale />} />
            <Route exact path='/cookie-policy' element={<Cookie />} />
            <Route exact path='/privacy-policy' element={<Privacy />} />
            <Route exact path='/intellectual-property' element={<IntellectualProperty />} />
            <Route exact path='/product/alexa-fluor-secondary' element={<AlexaFlourSecondary />} />
            <Route exact path='/product-release' element={<ProductRelease />} />
            <Route exact path='/nir' element={<NIR />} />
            <Route exact path='/product-search' element={<Gallery />} />
            <Route exact path='/product-search/:slug' element={<Gallery />} />
            <Route exact path='/product-search/:slug/:method' element={<Gallery />} />
            <Route exact path='/product/pathways' element={<Pathways />} />
            <Route exact path='/product/pathways/ssb' element={<Pathways />} />
            <Route exact path='/product/pathways/dsbhr' element={<Pathways />} />
            <Route exact path='/product/pathways/dsbnhej' element={<Pathways />} />
            <Route exact path='/identifyn-methods' element={<Methods />} />
            <Route exact path='/storm-calibration' element={<Storm />} />
            <Route exact path='/guarantee' element={<Guarantee />} />
            <Route exact path='/oem' element={<OEM />} />
            <Route exact path='/login' element={<HomePage />} />
            <Route exact path='/cart' element={<Cart />} />
            <Route element={<ProtectedRoute />}>
                <Route exact path='/profile/orders' element={<Orders />} />
                <Route exact path='/profile/account' element={<ProfileInformation />} />
                <Route exact path='/profile/billing-address' element={<BillingAddress />} />
                <Route exact path='/profile/shipping-address' element={<ShippingAddress />} />
                <Route exact path='/profile/tax-exempt' element={<TaxExempt />} />
                <Route exact path='/checkout' element={<Checkout />} />
            </Route>
            <Route path='*' element={<Error />} />
        </Routes>
    )
}
